import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const getMeetups = createAsyncThunk("getMeetups", async ({ page = 1, limit = 10, search = "", status = "" } = {}, { rejectWithValue }) => {
  try {
    const queryParams = new URLSearchParams();
    if (page) queryParams.append("page", page);
    if (limit) queryParams.append("limit", limit);
    if (search) queryParams.append("search", search);
    if (status) queryParams.append("status", status);

    const response = await axiosHttp.get(`meetup/list?${queryParams.toString()}`);
    return response.data;
  } catch (err) {
    if (!err.response) throw err;
    return rejectWithValue(err.response.data);
  }
});

const MeetupListSlice = createSlice({
  name: "MeetupListSlice",
  initialState: {
    isLoading: false,
    data: [],
    pagination: null,
    error: null,
  },
  reducers: {
    resetMeetupList: (state) => {
      state.isLoading = false;
      state.data = [];
      state.pagination = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMeetups.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getMeetups.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || [];
        state.pagination = action.payload?.pagination || null;
      })
      .addCase(getMeetups.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetMeetupList } = MeetupListSlice.actions;
export default MeetupListSlice.reducer;
